import createComponent from '@carvana/merch-components/createComponent';
import { ElementWithProps } from '@carvana/merch-components/dist';
import cx from 'classnames';

export const ContentRow = createComponent('div', {
  className: 'flex items-start gap-md'
});

export const ImageContainer = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('div', ({ disabled }) => ({
  className: cx('h-[120px] overflow-hidden rounded-md', {
    'opacity-50': disabled
  })
}));

export const OptionName = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('span', ({ disabled }) => ({
  className: cx(
    'min-w-0 flex-1 t-heading-xs',
    disabled ? 'text-text-disabled' : 'text-text-strong'
  )
}));

export const PriceAdd = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('span', ({ disabled }) => ({
  className: cx(
    'shrink-0 t-heading-xs',
    disabled ? 'text-text-disabled' : 'text-text-strong'
  )
}));

export const ImageUnavailable = createComponent('div', {
  className:
    'h-full flex items-center justify-center text-text-disabled t-body-sm !font-medium'
});

export const StockCount = createComponent('p', {
  className: 'mt-auto text-text-weak t-body-sm'
});
